const idNumberFormatter = new Intl.NumberFormat('id-ID', {
  maximumFractionDigits: 0
});

/**
 * Memformat integer Rupiah menjadi "Rp 150.000.000" (atau "-Rp 10.000.000" jika negatif).
 */
export function formatRupiah(amount: number): string {
  const intAmount = Math.trunc(amount);
  if (intAmount < 0) {
    return `-Rp ${idNumberFormatter.format(Math.abs(intAmount))}`;
  }
  return `Rp ${idNumberFormatter.format(intAmount)}`;
}

